/**
 * Le icone delle aree del menu (ADR 0202): un insieme fisso del sistema, a tratto su 24×24. Quale usa ogni area lo dice
 * la libreria (campo «icona» delle aree della base e dei mestieri); i nomi sono gli stessi controllati da
 * packages/standards/scripts/mestiere.mjs.
 */
export const AREA_ICONS: Record<string, string> = {
  casa: 'M3 10.5 12 4l9 6.5V20a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1z',
  persone: 'M16 20v-1.5A3.5 3.5 0 0 0 12.5 15h-5A3.5 3.5 0 0 0 4 18.5V20M10 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M20 20v-1.5a3.5 3.5 0 0 0-2.5-3.35M15.5 4.15a3.5 3.5 0 0 1 0 6.7',
  scatola: 'M21 8 12 3 3 8v8l9 5 9-5zM3 8l9 5 9-5M12 13v8',
  moneta: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M15.5 8.5A4 4 0 0 0 9 12a4 4 0 0 0 6.5 3.5M7 10.5h6M7 13.5h6',
  banca: 'M3 21h18M5 21V10M9 21V10M15 21V10M19 21V10M2 10l10-6 10 6z',
  documento: 'M14 3H6a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8zM14 3v5h5M8 13h8M8 17h6',
  contratto: 'M14 3H6a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8zM14 3v5h5M8 17c1.5-2 3-2 4 0s2.5 2 4 0',
  calcolatrice: 'M6 3h12a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1M8 7h8v3H8zM8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01',
  bilancia: 'M12 3v18M7 21h10M5 7h14M5 7l-3 7a3 3 0 0 0 6 0zM19 7l-3 7a3 3 0 0 0 6 0z',
  scudo: 'M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6z',
  valigia: 'M9 6V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1M4 6h16a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1M3 12h18',
  camion: 'M3 6h11v10H3zM14 9h4l3 3v4h-7M7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4M17 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4',
  carrello: 'M3 4h2l2.4 11h11l2-8H6.2M9 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2M18 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2',
  foglia: 'M5 21c0-9 5-15 15-16-1 10-7 15-15 16M5 21l8-8',
  lucchetto: 'M6 11h12v10H6zM8 11V7a4 4 0 0 1 8 0v4',
  ombrello: 'M12 3a9 9 0 0 0-9 9h18a9 9 0 0 0-9-9M12 12v7a2 2 0 0 0 4 0',
  rubrica: 'M6 3h13v18H6zM4 7h2M4 12h2M4 17h2M12.5 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4M9 16a3.5 3.5 0 0 1 7 0',
  grafico: 'M3 20h18M6 16l4-5 3 3 6-7M15 7h4v4',
  lista: 'M9 4h6v3H9zM9 5H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-3M9 13l2 2 4-4',
  fabbrica: 'M3 21V10l6 4v-4l6 4V6h5v15zM3 21h18',
  attrezzi: 'M15 5a4 4 0 0 0-5 5l-6 6 3 3 6-6a4 4 0 0 0 5-5l-2.5 2.5-2-2z',
  cantiere: 'M4 18a8 8 0 0 1 16 0zM2 18h20v2H2zM10 10V6h4v4',
  posate: 'M7 3v8M5 3v5a2 2 0 0 0 4 0V3M7 11v10M17 3c-2 0-3 3-3 7h3v11',
  salute: 'M3 12h4l2-4 3 8 2-4h7',
  scuola: 'M2 9l10-5 10 5-10 5zM6 11v5c3 2 9 2 12 0v-5',
  chiave: 'M15 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8M12.2 11.8 4 20M7 17l2 2M5 19l1.5 1.5',
  calendario: 'M4 6h16v15H4zM4 10h16M8 3v4M16 3v4',
  globo: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18M3 12h18M12 3c2.5 3 2.5 15 0 18M12 3c-2.5 3-2.5 15 0 18',
  schermo: 'M3 4h18v12H3zM8 20h8M12 16v4',
  fulmine: 'M13 2 4 14h7l-1 8 9-12h-7z',
  goccia: 'M12 3c4 5 6 8 6 11a6 6 0 0 1-12 0c0-3 2-6 6-11',
  provetta: 'M9 3h6M10 3v6l-5 9a2 2 0 0 0 2 3h10a2 2 0 0 0 2-3l-5-9V3M7.5 15h9',
  zampa: 'M12 20c-3 0-5-2-5-4s2-4 5-4 5 2 5 4-2 4-5 4M6 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M10 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M14 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M18 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3',
  negozio: 'M4 10v10h16V10M3 10l2-6h14l2 6zM9 20v-6h6v6',
  nave: 'M3 17l2 4h14l2-4zM5 17v-6h14v6M12 11V4M12 4l5 4h-5',
  medaglia: 'M12 15a6 6 0 1 0 0-12 6 6 0 0 0 0 12M8.5 14 7 21l5-3 5 3-1.5-7',
  megafono: 'M3 10v4h4l8 4V6l-8 4zM18 9a4 4 0 0 1 0 6',
  video: 'M3 7h13v10H3zM16 10l5-3v10l-5-3',
  libro: 'M4 4h6a3 3 0 0 1 2 1 3 3 0 0 1 2-1h6v15h-6a2 2 0 0 0-2 1 2 2 0 0 0-2-1H4zM12 5v15',
  rifiuti: 'M4 7h16M9 7V4h6v3M6 7l1 14h10l1-14',
  ingranaggio: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M5 19l2-2M17 7l2-2',
  etichetta: 'M3 12V4h8l10 10-8 8zM7.5 8.5h.01',
  montagna: 'M3 20 9 9l4 6 3-4 5 9z',
  letto: 'M3 18V7M3 13h18v5M21 13a3 3 0 0 0-3-3h-7v3M7 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3',
  luogo: 'M12 21s7-6 7-11a7 7 0 0 0-14 0c0 5 7 11 7 11M12 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4',
  musica: 'M9 18V5l11-2v13M9 18a3 3 0 1 1-6 0 3 3 0 0 1 6 0M20 16a3 3 0 1 1-6 0 3 3 0 0 1 6 0',
  griglia: 'M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z',
};
